
namespace RecordShield.Workspace {
    
    @Serenity.Decorators.registerClass()
    export class ProductItemsGrid extends Serenity.EntityGrid<ProductItemsRow, any> {
        protected getColumnsKey() { return 'Workspace.ProductItems'; }
        protected getDialogType() { return ProductItemsDialog; }
        protected getIdProperty() { return ProductItemsRow.idProperty; }
        protected getLocalTextPrefix() { return ProductItemsRow.localTextPrefix; }
        protected getService() { return ProductItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
		protected getInitialTitle() {
            return null;
        }

        protected addButtonClick() {

            this.editItem({ ProductId: this.productId });
        }

        protected usePager() {
            return false;
        }

        protected getGridCanLoad() {
            return this.productId != null;
        }

        private _productId: number;

        get productId() {
            return this._productId;
        }

        set productId(value: number) {
            if (this._productId != value) {
                this._productId = value;
                this.setEquality(ProductItemsRow.Fields.ProductId, value);
                this.refresh();
            }
        }

        protected getButtons(): Serenity.ToolButton[] {

            // call base method to get list of buttons
            // by default, base entity grid adds a few buttons, 
            // add, refresh, column selection in order.
            var buttons = super.getButtons();

            // here is several methods to remove add button
            // only one is enabled, others are commented

            // METHOD 1
            // we would be able to simply return an empty button list,
            // but this would also remove all other buttons
            // return [];

            // METHOD 2
            // remove by splicing (something like delete by index)
            // here we hard code add button index (not nice!)
            // buttons.splice(0, 1);

            // METHOD 3 - recommended
            // remove by splicing, but this time find button index
            // by its css class. it is the best and safer method
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            buttons.push(RecordShield.Common.ExcelExportHelper.createToolButton({
                grid: this,
                onViewSubmit: () => this.onViewSubmit(),
                service: 'Workspace/ProductItems/ListExcel',
                separator: true
            }));
            buttons.push(RecordShield.Common.PdfExportHelper.createToolButton({
                grid: this,
                onViewSubmit: () => this.onViewSubmit()
            }));


            return buttons;
        }
    }
}